<!-- <div class="intake-checkbox" class="form-item">
  <input
    [name]="field.key"
    [id]="field.key"
    type="checkbox"
    [formControl]="formControl"
    [formlyAttributes]="field"
  />
  <label [for]="field.key">{{ to.text }} </label> -->
<!-- <label *ngIf="showError">{{ getError() }} </label> -->
<!-- </div> -->

<div
  [ngClass]="
    to?.className === 'xilo-input' ? 'form-checkbox' : 'intake-checkbox'
  "
  class="form-item"
>
  <label class="checkbox-wrapper">
    <input
      [name]="field.key"
      [id]="field.key"
      type="checkbox"
      [formControl]="formControl"
      [formlyAttributes]="field"
      (change)="updateForm()"
    />
    <span class="checkmark"></span>
  </label>
  <label [for]="field.key" class="checkbox-label">{{ to.text }} </label>
</div>
